<template>
  <v-data-table
    class="custom-price-data-table gray10"
    :headers="headers"
    :items="items"
    hide-default-footer
    fixed-header
    ref="table"
    :header-props="{ 'sort-icon': '$sortIcon' }"
    :no-data-text="$t('common.nodata')"
  >
    <template v-slot:item.symbol="{ item }">
      <div class="d-flex align-center">
        <v-btn icon @click="toggleFavorite(item)" v-if="isAuth">
          <v-icon
            :class="[
              'favorite-icon',
              {
                'svg-color-secondary': item.isFavor
              }
            ]"
            class="me-2"
            style="cursor: pointer"
            size="12"
            >$favoriteStar
          </v-icon>
        </v-btn>
        <img
          v-if="item.coinUrl"
          :src="item.coinUrl"
          alt=""
          height="20"
          width="20"
          @error="setDefaultLogo"
        />
        <img
          v-else
          :src="require('@/assets/image/coin_place_holder.png')"
          alt=""
          height="20"
          width="20"
          @error="setDefaultLogo"
        />
        <span class="ms-2 pt-1 font-Regular-10">
          {{ item.symbol }}
        </span>
      </div>
    </template>
    <template v-slot:item.close="{ item }">
      <span class="font-Regular-12 text-center">
        {{ $thousandMask(item.close, item.baseCoinScale) }}
      </span>
    </template>
    <template v-slot:item.chg="{ item }">
      <p
        class="mb-0 ltr text-end"
        :class="
          item.chg >= 0 ? (item.chg === 0 ? '' : 'green--text') : 'red--text'
        "
      >
        <span v-if="item.chg > 0">+</span>
        <span>{{ (item.chg * 100).toFixed(2) }}%</span>
      </p>
    </template>
    <template v-slot:item.high="{ item }">
      <span class="font-Regular-12">
        {{ $thousandMask(item.high, item.baseCoinScale) }}
      </span>
    </template>
    <template v-slot:item.low="{ item }">
      <span class="font-Regular-12">
        {{ $thousandMask(item.low, item.baseCoinScale) }}
      </span>
    </template>
    <template v-slot:item.volume="{ item }">
      <span class="font-Regular-12">
        {{ item.volume ? $thousandMask(item.volume, item.baseCoinScale) : "" }}
      </span>
    </template>
    <template v-slot:item.trend="{ item }">
      <svg-line
        :values="item.trend.length > 0 ? item.trend : defaultTrend"
        :rose="`${item.chg}`"
        :coin="item.displayName"
        :width="100"
        :height="25"
      />
    </template>
    <template v-slot:item.operation="{ item }">
      <v-btn
        color="primary"
        text
        class="ms-2"
        :href="
          `${marketBaseUrl}/exchange/${item.coinSymbol}_${item.baseSymbol}`
        "
        >{{ $t("marketsPage.trading") }}
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import $thousandMask from "@/mixins/thousandMask";
import SvgLine from "@/components/SvgLine/index.vue";
import { ExchangeService } from "@/services";
import { authMixin } from "@/mixins/authMixin";

export default {
  mixins: [$thousandMask, authMixin],
  name: "marketsTable",
  components: { SvgLine },
  props: {
    items: {
      type: Array
    },
    currentTab: {
      type: Object
    }
  },
  data() {
    return {
      marketBaseUrl: process.env.VUE_APP_MARKET_BASE_URL,
      defaultTrend: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      headers: [
        {
          text: this.$t("marketsPage.coin"),
          value: "symbol",
          align: "start"
        },
        {
          text: this.$t("marketsPage.newPrice"),
          value: "close",
          align: "start"
        },
        {
          text: this.$t("marketsPage.change"),
          value: "chg",
          align: "start"
        },
        {
          text: this.$t("marketsPage.high"),
          value: "high",
          align: "start"
        },
        {
          text: this.$t("marketsPage.low"),
          value: "low",
          align: "start"
        },
        {
          text: this.$t("marketsPage.exchangeNum"),
          value: "volume",
          align: "start"
        },
        {
          text: this.$t("marketsPage.priceTrend"),
          value: "trend",
          align: "start",
          sortable: false
        },
        {
          text: this.$t("marketsPage.operate"),
          value: "operation",
          align: "center",
          sortable: false
        }
      ]
    };
  },
  methods: {
    setDefaultLogo(e) {
      e.target.src = require("@/assets/image/coin_place_holder.png");
    },
    toggleFavorite(item) {
      let payload = {
        symbol: item.symbol
      };
      const api = !item.isFavor
        ? ExchangeService.addFavoredMarkets
        : ExchangeService.deleteFavoredMarkets;
      api(payload)
        .then(response => {
          if (response.data.code === 0) {
            this.$toast.success(
              !item.isFavor
                ? this.$t("marketsPage.addToFavorites")
                : this.$t("marketsPage.removeFavorites")
            );
            if (!this.currentTab) {
              this.$emit("getFavor");
            } else {
              this.$emit("updateItems", { item, value: !item.isFavor });
            }
          }
        })
        .catch(err => {
          this.$toast.error(err.message);
        });
    }
  }
};
</script>
<style scoped lang="scss"></style>
